import { AfterViewChecked, AfterViewInit, ElementRef, Injectable, Input, Renderer2 } from '@angular/core';
import { InformationNoteModel } from '../../model/information-note';

@Injectable()
export abstract class InformationNoteComponent<TModel extends InformationNoteModel> implements AfterViewInit, AfterViewChecked {
  @Input() dataContext: TModel[] = [];
  constructor(private _renderer: Renderer2) {}

  protected abstract tooltipBlock: ElementRef<HTMLInputElement>;
  protected abstract tooltipIcon: ElementRef<HTMLInputElement>;

  private tooltipMaxHeight = 350;
  private tooltipWidthThreshold = 250;

  ngAfterViewInit(): void {
    this.correctTooltipPosition();
  }

  ngAfterViewChecked(): void {
    this.correctTooltipPosition();
  }

  isClickable: boolean = false;
  click(event: MouseEvent, itemData: TModel): void {
    event.stopPropagation();
  }

  private correctTooltipPosition(): void {
    if (this.dataContext.length > 0) {
      const tooltipRect = this.tooltipBlock.nativeElement.getBoundingClientRect();
      const iconRect = this.tooltipIcon.nativeElement.getBoundingClientRect();
      const windowWidth = window.innerWidth;
      const windowHeight = window.innerHeight;

      if (windowWidth - iconRect.left < this.tooltipWidthThreshold) {
        this._renderer.setStyle(this.tooltipBlock.nativeElement, 'left', `-200px`);
      } else {
        this._renderer.setStyle(this.tooltipBlock.nativeElement, 'left', `0px`);
      }

      if (windowHeight - iconRect.bottom < this.tooltipMaxHeight) {
        this._renderer.setStyle(this.tooltipBlock.nativeElement, 'top', `-${tooltipRect.height}px`);
      } else {
        this._renderer.setStyle(this.tooltipBlock.nativeElement, 'top', `${iconRect.height + 15}px`);
      }
    }
  }
}
